import { cn } from "@/lib/utils";
import type { RequestStatus } from "@/types";

type Tone = "neutral" | "brand" | "success" | "warning" | "danger" | "info";

const toneClasses: Record<Tone, string> = {
  neutral: "bg-slate-100 text-slate-700 ring-slate-200",
  brand: "bg-brand-50 text-brand-700 ring-brand-200",
  success: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  warning: "bg-amber-50 text-amber-700 ring-amber-200",
  danger: "bg-red-50 text-red-700 ring-red-200",
  info: "bg-sky-50 text-sky-700 ring-sky-200",
};

export function Badge({
  tone = "neutral",
  className,
  children,
}: {
  tone?: Tone;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium ring-1 ring-inset",
        toneClasses[tone],
        className
      )}
    >
      {children}
    </span>
  );
}

const statusTones: Record<RequestStatus, Tone> = {
  pending: "warning",
  verified: "info",
  issued: "success",
  rejected: "danger",
  revoked: "danger",
  expired: "neutral",
};

export function StatusBadge({ status }: { status: RequestStatus }) {
  return <Badge tone={statusTones[status]}>{status}</Badge>;
}
